var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.$bus.$emit('quoteForm')}}},[_vm._v("\n    Get a quote\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }